import { toast as showToast } from '@/components/ui/use-toast';
import { ToastProps } from '@/types/toast';

export const useToast = () => {
  const toast = (props: ToastProps) => {
    showToast({
      ...props,
      duration: props.duration ?? 5000, // Default to 5 seconds if not specified
    });
  };

  return { toast };
};